import { IonIcon } from '@ionic/react';
import { checkmarkCircle } from 'ionicons/icons';

interface VerificationCodeProps {
  code: number;
  /** The eater has confirmed their half of the handoff; the ticket turns green. */
  confirmed?: boolean;
}

/**
 * Read-only handoff number, shown identically to both parties so the eater and
 * the lister are looking at the same thing when they read it aloud. Deliberately
 * not a button: the confirm action lives in its own rectangle below it, so the
 * number reads as something to say, not something to tap. Styled as a pickup
 * ticket in `.hp-verify-code` (global.scss).
 */
export const VerificationCode: React.FC<VerificationCodeProps> = ({ code, confirmed = false }) => (
  // Tinted rather than solid: a solid brand fill would read as a twin of the
  // filled confirm button below it, which is the confusion this replaced.
  <div className={`hp-verify-code ${confirmed ? 'hp-verify-code--confirmed' : ''}`}>
    <span className="text-6xl font-extrabold leading-none tabular-nums tracking-wider">
      <span className="hp-verify-code__hash">#</span>
      {code}
    </span>
    {confirmed && <IonIcon icon={checkmarkCircle} className="hp-verify-code__badge" aria-hidden />}
  </div>
);
